import { SuperAdminEditViewModal } from "features/withdraw/components/modal/super-admin-edit";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "routes/constants";
// ../components/modal/withdraw-detail
// ../components/modal/super-admin-edit
export const SuperAdminApproveView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.SUPER_ADMIN);
  };

  return (
    <SuperAdminEditViewModal
      id={id}
      onClose={closeModal}
      onSuccess={closeModal}
    />
  );
};
